<template>
  <div style="width:100%;display:flex;position:relative">
    <transition name="fade">
      <div class="emoji pa-3" v-if="showEmoji" v-click-outside="hideEmojiPane">
        <span
          v-for="(e, i) in emojis"
          :key="i"
          style="cursor:pointer"
          @mousedown="clickEmoji(e)"
          @mouseup="emojiClicked"
          >{{ e }}</span
        >
      </div>
    </transition>
    <div class="pa-2">
      <v-icon @click="showEmojiPane">mdi-emoticon-outline</v-icon>
    </div>
    <div
      :class="{ disabled: sending }"
      class="text pa-2"
      :placeholder="placeholder"
      contenteditable="true"
      ref="textarea"
      @keypress="keyEvent"
      @focus="$emit('focus')"
    ></div>
    <div class="pa-2">
      <v-icon @click="send" :class="{ disabled: sending }">mdi-send</v-icon>
    </div>
  </div>
</template>

<script>
// import { api } from "@/api";

export default {
  name: "HiTextArea",
  props: {
    placeholder: {
      type: String,
      default: "Type your post here. CTRL + ENTER to submit..."
    }
    // param: {
    //   type: Object
    // },
    // handler: {
    //   type: Function,
    //   required: true
    // }
  },
  data() {
    return {
      showEmoji: false,
      emojis: [
        ..."😃😄😁😆😅😂🙂😉😇😷😕😓😟😩😱👏🖐👌🤏✌🤞👍👎👈👆👇☝✊👊⭐🙈🙉🙊🐕🐈🐶🐱🦊🌞"
      ],
      selRange: null,
      sending: false
    };
  },
  methods: {
    saveSelection() {
      if (window.getSelection) {
        const sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          return sel.getRangeAt(0);
        }
      } else if (document.selection && document.selection.createRange) {
        return document.selection.createRange();
      }
      return null;
    },
    restoreSelection(range) {
      if (range) {
        if (window.getSelection) {
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } else if (document.selection && range.select) {
          range.select();
        }
      }
    },
    showEmojiPane() {
      this.showEmoji = true;
      const ctl = this.$refs.textarea;

      ctl.focus();
    },
    hideEmojiPane() {
      this.showEmoji = false;
    },
    clickEmoji(e) {
      const ctl = this.$refs.textarea;
      ctl.focus();
      if (this.selRange) {
        this.selRange.deleteContents();
        const node = document.createTextNode(e);
        this.selRange.insertNode(node);
        this.selRange.collapse();
        let self = this;
        setTimeout(() => {
          self.restoreSelection(self.selRange);
        }, 1);
      }
    },
    emojiClicked() {
      const ctl = this.$refs.textarea;
      ctl.focus();
    },
    selectionChange() {
      // console.log(document.getSelection());
      const sel = document.getSelection();
      const anchor = sel.anchorNode;
      const focus = sel.focusNode;
      const ta = this.$refs.textarea;
      if (ta.contains(anchor) && ta.contains(focus)) {
        this.selRange = this.saveSelection();
      }
    },
    keyEvent(e) {
      // console.log(e.keyCode);
      const code = e.keyCode;
      if (code === 10 || (e.ctrlKey && code === 13)) {
        e.preventDefault();
        this.send();
      }
    },
    send() {
      //send textarea.innerHTML
      //events: successful/error/
      // const data = {
      //   message: this.$refs.textarea.innerHTML,
      //   targetId: this.leadId
      // };
      // console.log("calling leadsComment", data);
      // api.leads
      //   .leadsComment(data)
      //   .then(() => {
      //     this.$refs.textarea.innerHTML = null;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });

      // const result = await this.handler(this.$refs.textarea.innerHTML);
      // if (result.ok) {
      // }
      //   this.$refs.textarea.innerHTML = "";
      if (this.sending) {
        return;
      }
      this.$emit("send", this.$refs.textarea.innerHTML);
      this.sending = true;
    },
    restart(keepContent) {
      this.sending = false;
      if (!keepContent) this.$refs.textarea.innerText = "";
    }
  },
  mounted() {
    document.addEventListener("selectionchange", this.selectionChange);
  },
  destroyed() {
    document.removeEventListener("selectionchange", this.selectionChange);
  }
};
</script>

<style scoped>
.text {
  flex-grow: 1;
  cursor: text;
}

.text[placeholder]:empty:before {
  content: attr(placeholder);
  color: #555;
  opacity: 0.3;
}

.text:focus {
  outline: none;
}

.emoji {
  position: absolute;
  left: 0;
  bottom: 100%;
  border: 1px solid #999999;
  width: 100%;
  background-color: white;
}
.disabled {
  opacity: 0.5;
}
</style>
